import { PlusCircleOutlined } from "@ant-design/icons";
import { Button } from "antd";
import React from 'react';
import { useSelector } from 'react-redux';
import { openPopup2 } from "../../../../../contexts/PopupContext";
import { selectPermissions } from '../../../../../util/store/selectors';
import { ACTION } from '../../../../../util/varibles/permission';
import PopupEditExternalSite from "../../../Popup/EditExternalSite";

const AddExternalSite: React.FC = () => {
    const [canAddExternalSite] = useSelector(selectPermissions([ACTION.PLAN_OP.EXTERNAL_SITE]));

    if (!canAddExternalSite)
        return null;

    const openEditExternalSite = () => {
        openPopup2(<PopupEditExternalSite />, { modalProps: { title: "Add external site, unit", width: 460 } })
    }

    return <Button className='bt-ghost' data-icon={true} onClick={openEditExternalSite}>
        <PlusCircleOutlined style={{ fontSize: '19px', marginLeft: '-1px' }} />
    </Button>;
};

export default AddExternalSite;
